"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisibilityData = exports.DialogVariants = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var DomUtils_1 = require("epc-web-utils/dist/DomUtils");
var LocaleUtils_1 = require("epc-web-utils/dist/LocaleUtils");
var Button_1 = __importStar(require("../button/Button"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var IDUtils_1 = require("../../utils/IDUtils");
var KeyboardEventKeys_1 = __importDefault(require("../../common/enums/KeyboardEventKeys"));
var ExperimentalComponentUtils_1 = require("../../utils/ExperimentalComponentUtils");
var CLASS_NAME_IS_HIDDEN = 'is-hidden';
var CLASS_NAME_DIALOG = 'fds-dialog';
var CLASS_NAME_DIALOG_BACKDROP = 'fds-dialog-backdrop';
var CLASS_NAME_DIALOG_PANEL = 'fds-dialog-panel';
var CLASS_NAME_DIALOG_PANEL_HUB = 'fds-dialog-panel-hub-and-spoke-view';
var DialogVariants;
(function (DialogVariants) {
    DialogVariants["DEFAULT"] = "default";
    DialogVariants["PANEL"] = "panel";
    DialogVariants["PANEL_HUB_AND_SPOKE"] = "panelHubAndSpoke"; //TODO: Deprecate panelHubAndSpoke
})(DialogVariants = exports.DialogVariants || (exports.DialogVariants = {}));
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogBackdrop = react_1.default.createRef();
        _this.dialog = react_1.default.createRef();
        _this.handleMouseClick = function (e) {
            DomUtils_1.hasClass(e.target, 'fds-dialog-backdrop') && _this.closeDialogReject();
        };
        _this.cleanUp = function () {
            // Prep DOM for dialog closing
            DomUtils_1.removeClass(document.documentElement, 'fds-dialog-open');
            DomUtils_1.removeClass(document.documentElement, 'fds-fullscreen-view');
        };
        _this.handleKeyDown = function (e) {
            var focusableElementsSelector = "\n            .fds-button,\n            a[href],\n            area[href],\n            input:not([disabled]),\n            select:not([disabled]),\n            textarea:not([disabled]),\n            button:not([disabled]),\n            [tabindex=\"0\"]\n        ";
            var focusableElements = Array.from(_this.dialogBackdrop.current.querySelectorAll(focusableElementsSelector));
            var filteredFocusableElements = focusableElements.filter(function (item) { return item.offsetParent !== null; });
            function handleBackwardTab() {
                if (document.activeElement === filteredFocusableElements[0]) {
                    e.preventDefault();
                    filteredFocusableElements[0].focus();
                }
            }
            function handleForwardTab() {
                var index = filteredFocusableElements.length - 1;
                if (document.activeElement === filteredFocusableElements[index]) {
                    e.preventDefault();
                    filteredFocusableElements[0].focus();
                }
            }
            switch (e.key) {
                case KeyboardEventKeys_1.default.TAB:
                    if (focusableElements.length === 1) {
                        e.preventDefault();
                        break;
                    }
                    if (e.shiftKey) {
                        handleBackwardTab();
                    }
                    else {
                        handleForwardTab();
                    }
                    break;
                case KeyboardEventKeys_1.default.ESCAPE:
                    _this.closeDialogReject();
                    break;
                default:
                    break;
            }
        };
        _this.closeDialogReject = function () {
            var _a = _this.props, lastFocused = _a.lastFocused, onRequestCloseReject = _a.onRequestCloseReject;
            var lastFocusedElem = document.querySelector(lastFocused);
            lastFocusedElem && lastFocusedElem.focus();
            typeof onRequestCloseReject === 'function' && onRequestCloseReject();
        };
        _this.closeDialogConfirm = function () {
            var onRequestCloseConfirm = _this.props.onRequestCloseConfirm;
            typeof onRequestCloseConfirm === 'function' && onRequestCloseConfirm();
        };
        _this.revertBack = function () {
            var onRequestBack = _this.props.onRequestBack;
            typeof onRequestBack === 'function' && onRequestBack();
        };
        _this.renderBackButton = function (ariaCloseButtonLabel) {
            return (react_1.default.createElement(Button_1.default, { "aria-label": ariaCloseButtonLabel, classes: "fds-dialog-confirm dialog-back", onClick: _this.revertBack, type: Button_1.ButtonType.ROUND },
                react_1.default.createElement(Icon_1.default, { name: "arrow-back" })));
        };
        _this.renderCloseButton = function (ariaCloseButtonLabel) {
            return (react_1.default.createElement(Button_1.default, { "aria-label": ariaCloseButtonLabel, classes: "fds-dialog-dismiss dialog-close", onClick: _this.closeDialogReject, type: Button_1.ButtonType.ROUND, variant: Button_1.RoundButtonType.FLAT },
                react_1.default.createElement(Icon_1.default, { name: "close" })));
        };
        _this.startUp = function () {
            var _a = _this.props, variant = _a.variant, fullScreen = _a.fullScreen;
            // Prep DOM for dialog opening
            DomUtils_1.addClass(document.documentElement, 'fds-dialog-open');
            if (variant === DialogVariants.PANEL || variant === DialogVariants.PANEL_HUB_AND_SPOKE || fullScreen) {
                DomUtils_1.addClass(document.documentElement, 'fds-fullscreen-view');
            }
        };
        return _this;
    }
    Dialog.prototype.renderDismissButton = function (multiStep, ariaCloseButtonLabel) {
        return multiStep ?
            this.renderBackButton(ariaCloseButtonLabel) :
            this.renderCloseButton(ariaCloseButtonLabel);
    };
    Dialog.prototype.renderAdditionalDismissButton = function (multiStep, ariaCloseButtonLabel) {
        return multiStep ?
            this.renderCloseButton(ariaCloseButtonLabel) :
            null;
    };
    Dialog.prototype.triggerStateEvent = function (unmounted) {
        if (unmounted === void 0) { unmounted = false; }
        var _a = this.props, open = _a.open, variant = _a.variant;
        // force visible to false when unmounted because an unmount always has stale props
        // without this, the component may report 'open: true' when it is hidden 
        // (in cases where apps conditionally render dialog and pass dynamic props)
        var visible = unmounted ? false : open;
        var offsetDirection = getOffsetDirection(variant);
        var offset = getOffset(this.dialog.current, visible);
        var eventDetails = { visible: visible, offset: offset, offsetDirection: offsetDirection, variant: variant };
        DomUtils_1.triggerEvent('Ferris.Components.Dialog.Visibility', eventDetails);
    };
    Dialog.prototype.componentDidMount = function () {
        var open = this.props.open;
        this.triggerStateEvent();
        if (open) {
            this.startUp();
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        this.triggerStateEvent(true);
    };
    Dialog.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, open = _a.open, variant = _a.variant;
        if (variant !== prevProps.variant) {
            this.triggerStateEvent();
        }
        if (open !== prevProps.open) {
            this.triggerStateEvent();
            open && this.dialogBackdrop.current.focus();
            if (!open) {
                this.cleanUp();
            }
            else {
                this.startUp();
            }
        }
    };
    Dialog.prototype.render = function () {
        var _a = this.props, children = _a.children, classes = _a.classes, collapsePadding = _a.collapsePadding, confirmationText = _a.confirmationText, confirmButtonDisabled = _a.confirmButtonDisabled, discardText = _a.discardText, fullScreen = _a.fullScreen, fullScreenConfirmationButtonEnabled = _a.fullScreenConfirmationButtonEnabled, fullScreenConfirmationText = _a.fullScreenConfirmationText, headerText = _a.headerText, multiStep = _a.multiStep, open = _a.open, showHeader = _a.showHeader, showFooter = _a.showFooter, variant = _a.variant, panelUtilityButtons = _a.panelUtilityButtons, footerContentBefore = _a.footerContentBefore, footerContentAfter = _a.footerContentAfter;
        var isDefaultPanelVariant = variant === DialogVariants.PANEL;
        var isHubAndSpokePanelVariant = variant === DialogVariants.PANEL_HUB_AND_SPOKE; //TODO: Deprecate isHubAndSpokePanelVariant
        var isPanelVariant = isDefaultPanelVariant || isHubAndSpokePanelVariant;
        var dialogBackDropClasses = getBackDropClassNames(open, isPanelVariant, isHubAndSpokePanelVariant, multiStep, classes);
        var dialogClasses = getDialogClassNames(fullScreen, collapsePadding);
        var footerConfirmBtnType = isPanelVariant ? Button_1.ButtonType.PRIMARY : Button_1.ButtonType.ACTION;
        var dialogTitleId = IDUtils_1.generateRandomId();
        var ariaCloseButtonLabel = discardText || 'Close'; //FIXME: LOCALIZE THIS
        var dismissButton = this.renderDismissButton(multiStep || isHubAndSpokePanelVariant, ariaCloseButtonLabel); //TODO: Deprecate isHubAndSpokePanelVariant
        var additionalDismissButton = this.renderAdditionalDismissButton(multiStep || isHubAndSpokePanelVariant, ariaCloseButtonLabel); //TODO: Deprecate isHubAndSpokePanelVariant
        isHubAndSpokePanelVariant && ExperimentalComponentUtils_1.logExperimentalComponent('hub and spoke panel dialog');
        return (react_1.default.createElement("div", { className: dialogBackDropClasses, tabIndex: -1, onKeyDown: this.handleKeyDown, onMouseDown: this.handleMouseClick, ref: this.dialogBackdrop },
            react_1.default.createElement("div", { ref: this.dialog, className: dialogClasses, role: "dialog", "aria-labelledby": dialogTitleId, "aria-modal": "true" },
                showHeader && (react_1.default.createElement("header", { className: "fds-dialog-header" },
                    dismissButton,
                    react_1.default.createElement("h3", { id: dialogTitleId, className: "fds-dialog-title" }, headerText),
                    additionalDismissButton,
                    fullScreenConfirmationButtonEnabled && (react_1.default.createElement(Button_1.default, { classes: "fds-dialog-confirm dialog-close", disabled: confirmButtonDisabled, onClick: this.closeDialogConfirm, type: Button_1.ButtonType.ACTION }, fullScreenConfirmationText)))),
                react_1.default.createElement("div", { className: "fds-dialog-content" }, children),
                showFooter && (react_1.default.createElement("footer", { className: "fds-dialog-footer" }, isPanelVariant ? (react_1.default.createElement(react_1.default.Fragment, null,
                    footerContentBefore && (react_1.default.createElement("div", { className: "fds-dialog-footer-content" }, footerContentBefore)),
                    react_1.default.createElement("div", { className: "fds-dialog-footer-button-container" },
                        confirmationText && (react_1.default.createElement(Button_1.default, { classes: "fds-dialog-confirm", disabled: confirmButtonDisabled, onClick: this.closeDialogConfirm, type: footerConfirmBtnType }, confirmationText)),
                        isPanelVariant && panelUtilityButtons),
                    footerContentAfter && (react_1.default.createElement("div", { className: "fds-dialog-footer-content" }, footerContentAfter)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    discardText && (react_1.default.createElement(Button_1.default, { classes: "fds-dialog-dismiss fds-dialog-cancel", onClick: this.closeDialogReject, type: Button_1.ButtonType.ACTION, variant: Button_1.ActionButtonType.SECONDARY }, discardText)),
                    confirmationText && (react_1.default.createElement(Button_1.default, { classes: "fds-dialog-confirm", disabled: confirmButtonDisabled, onClick: this.closeDialogConfirm, type: footerConfirmBtnType }, confirmationText)))))))));
    };
    Dialog.defaultProps = {
        fullScreenConfirmationButtonEnabled: false,
        fullScreenConfirmationText: 'Save',
        showHeader: true,
        showFooter: true,
        variant: DialogVariants.DEFAULT
    };
    return Dialog;
}(react_1.default.Component));
exports.default = Dialog;
/**
* Check the DOM for the current state of the Dialog component, and return a data object containing
* visiblity and offset information.
*/
var getVisibilityData = function () {
    var dialogBackdropComponent = document.querySelector("." + CLASS_NAME_DIALOG_BACKDROP);
    var dialogComponent = dialogBackdropComponent ?
        dialogBackdropComponent.querySelector("." + CLASS_NAME_DIALOG) :
        null;
    var visible = dialogBackdropComponent ?
        dialogBackdropComponent.className.indexOf(CLASS_NAME_IS_HIDDEN) === -1 :
        false;
    var variant = (function (dialogBackdropComponent) {
        if (dialogBackdropComponent && dialogBackdropComponent.className.indexOf(CLASS_NAME_DIALOG_PANEL_HUB) !== -1) {
            return DialogVariants.PANEL_HUB_AND_SPOKE;
        }
        else if (dialogBackdropComponent && dialogBackdropComponent.className.indexOf(CLASS_NAME_DIALOG_PANEL) !== -1) {
            return DialogVariants.PANEL;
        }
        return DialogVariants.DEFAULT;
    })(dialogBackdropComponent);
    var offsetDirection = getOffsetDirection(variant);
    var offset = getOffset(dialogComponent, visible);
    return { visible: visible, offset: offset, offsetDirection: offsetDirection, variant: variant };
};
exports.getVisibilityData = getVisibilityData;
var getBackDropClassNames = function (open, isDialogPanelVariant, isHubAndSpokePanelVariant, multiStep, classes) {
    var _a;
    return classnames_1.default('fds-dialog-backdrop', (_a = {},
        _a[CLASS_NAME_IS_HIDDEN] = !open,
        _a['fds-dialog-panel'] = isDialogPanelVariant,
        _a['fds-dialog-panel-hub-and-spoke-view'] = isHubAndSpokePanelVariant,
        _a['fds-dialog-multi-step'] = isHubAndSpokePanelVariant || multiStep ? multiStep : false,
        _a), classes);
};
var getDialogClassNames = function (fullScreen, collapsePadding) {
    return classnames_1.default('fds-dialog', {
        'fds-dialog-fullscreen': fullScreen,
        'collapse-padding': collapsePadding
    });
};
var getOffset = function (component, visible) {
    return typeof window !== 'undefined' && visible ?
        parseInt(window.getComputedStyle(component).width, 10) :
        0;
};
var getOffsetDirection = function (variant) {
    var _a;
    if (variant === DialogVariants.PANEL || variant === DialogVariants.PANEL_HUB_AND_SPOKE) {
        // FIXME: Remove after epc-web-utils casing fix PR is released: https://github.expedia.biz/LodgingPlatform/epc-web-utils/pull/13
        return ((_a = LocaleUtils_1.getLanguageDirection()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'ltr' ? 'right' : 'left';
    }
    return 'bottom';
};
